export function formatDate(date) {
    date = new Date(date);
    let dateFormat = [
        ("0000" + date.getFullYear()).slice(-4),
        ("00" + (date.getMonth() + 1)).slice(-2),
        ("00" + date.getDate()).slice(-2),
    ].join('-') + ' ' +
        [
            ("00" + date.getHours()).slice(-2),
            ("00" + date.getMinutes()).slice(-2),
            ("00" + date.getSeconds()).slice(-2)
        ].join(':');
    return dateFormat;
}

export function formatDateAdvance({ date = new Date(), separator = '-' } = {}) {

    let dateFormat = [
        ("0000" + date.getFullYear()).slice(-4),
        ("00" + (date.getMonth() + 1)).slice(-2),
        ("00" + date.getDate()).slice(-2),
    ].join(separator);
    return dateFormat;
}

export function formatDateUnixTimestamp(date) {
    date = new Date(date * 1000);
    let dateFormat = [
        ("0000" + date.getFullYear()).slice(-4),
        ("00" + (date.getMonth() + 1)).slice(-2),
        ("00" + date.getDate()).slice(-2),
    ].join('-') + ' ' +
        [
            ("00" + date.getHours()).slice(-2),
            ("00" + date.getMinutes()).slice(-2),
            ("00" + date.getSeconds()).slice(-2)
        ].join(':');
    return dateFormat;
}

export function getDate({ date = new Date(), time = '00:00:00', prev_days = 0, next_days = 0 } = {}) {
    var today = date;

    if (typeof time == 'string')
        time = time.split(':');
    let final_date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - prev_days + next_days, ...time);
    return final_date;
}

export function getRangeDateThisMonth() {
    const currentDate = new Date();
    const firstDayMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 23, 59, 59);
    return {
        start: firstDayMonth,
        end: lastDayMonth
    }
}

export function initRangeDate() {
    return {
        start: formatDate(getDate({
            date: new Date(),
            prev_days: 7
        })),
        end: formatDate(getDate({
            date: new Date(),
            time: '23:59:59',
            prev_days: 0
        }))
    }
}

export function adapterCreatedAtInChars(data) {
    data.forEach(item => {
        if (item._items) {
            item._items.forEach(element => {
                element.created_at = element.created_at.split(" ")[0];
            });
        } else {
            item.forEach(element => {
                element.created_at = element.created_at.split(" ")[0];
            });
        }

    });
}

export function getIntervalDateCurrentWeek() {
    let date = new Date();
    let day = date.getDay();
    let diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    let start = new Date(date.setDate(diff));
    let end = new Date(date.setDate(diff + 6));
    return {
        from: formatDate(start),
        to: formatDate(end)
    }
}

export function getIntervalDateCurrentMonth() {
    let date = new Date();
    let start = new Date(date.getFullYear(), date.getMonth(), 1);
    let end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return {
        from: formatDate(start),
        to: formatDate(end)
    }
}

export function getDateFromDatetime(datetime, separator = "-") {
    let date = new Date(datetime);
    return [
        ("0000" + date.getFullYear()).slice(-4),
        ("00" + (date.getMonth() + 1)).slice(-2),
        ("00" + date.getDate()).slice(-2),
    ].join(separator);
}
